import { BookOpen, ClipboardList, MessageCircle } from "lucide-react";

const features = [
  {
    Icon: BookOpen,
    title: "Adaptive PTE practice",
    description:
      "Work through speaking, writing, reading, and listening tasks with AI feedback that adapts to your performance.",
  },
  {
    Icon: ClipboardList,
    title: "Unlimited mock tests",
    description:
      "Build exam confidence with full mock tests, instant scoring, and detailed reports after every attempt.",
  },
  {
    Icon: MessageCircle,
    title: "Clear feedback loops",
    description:
      "See exactly where to improve with section-wise insights, score trends, and focused next-step guidance.",
  },
];

const CoreFeatures = () => {
  return (
    <section className="bg-white px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-gray-500">
            Core features
          </p>
          <h2 className="mt-3 text-3xl font-black tracking-tight text-gray-950 sm:text-4xl">
            Everything you need to practise, measure, and improve.
          </h2>
          <p className="mt-4 text-base leading-7 text-gray-600">
            A focused preparation workspace for PTE aspirants who want useful
            feedback instead of guesswork.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {features.map((feature) => (
            <article
              key={feature.title}
              className="rounded-lg border border-gray-200 bg-gray-50 p-6 transition hover:-translate-y-1 hover:bg-white hover:shadow-xl hover:shadow-gray-900/10"
            >
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-gray-900 text-white">
                <feature.Icon className="h-6 w-6" />
              </div>
              <h3 className="mt-6 text-xl font-bold text-gray-950">
                {feature.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-gray-600">
                {feature.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreFeatures;
